// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  fnLedgerId: __t.u64().primaryKey().name("fn_ledger_id"),
  settlementId: __t.u64().name("settlement_id"),
  fn: __t.string(),
  cash: __t.i64(),
  revenueDay: __t.i64().name("revenue_day"),
  wageBillDay: __t.i64().name("wage_bill_day"),
  dayBucket: __t.u32().name("day_bucket"),
  updatedAt: __t.timestamp().name("updated_at"),
});
